import { ReactComponent as LoadingIcon } from 'assets/icons/refresh.svg'
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg'
import { useState, useEffect, memo } from 'react'
import { FormStatus } from '@/types';

interface CalloutProps {
    children: React.ReactNode;
    type?: 'info' | 'warning' | 'error' | 'success' | 'neutral';
    loadingIcon?: boolean;
    id?: string;
    title?: string;
    className?: string;
}

const Callout: React.FC<CalloutProps> = ({ children, type, loadingIcon, id, title, className }) => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        if (id) {
            const isClosed = localStorage.getItem(`callout-closed-${id}`);
            if (isClosed) {
                setIsVisible(false);
            }
        }
    }, [id]);

    const handleClose = () => {
        if (id) {
            localStorage.setItem(`callout-closed-${id}`, 'true');
        }
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className={`
            bg-gray-10
            p-6
            flex
            flex-row
            justify-between
            rounded-md
            gap-x-1
            relative
            col-span-full
            ${type === 'warning' ? 'bg-yellow-100' : ''}
            ${type === 'error' ? 'bg-red-100' : ''}
            ${type === 'success' ? 'bg-green-100' : ''}
            ${type === 'info' ? 'bg-blue-100' : ''}
            ${type === 'neutral' ? 'bg-gray-100' : ''}
            ${className || ''}
        `} data-type={type}>
            <div className={`
                flex
                flex-col
                gap-y-4
                w-[calc(100%-40px)]
            `}>
                {loadingIcon && <LoadingIcon className="animate-spin w-8 h-8 fill-black mr-2" />}
                {title && <h3 className="font-bold capitalize">{title}</h3>}
                {
                    typeof children === 'string' ? <span dangerouslySetInnerHTML={{ __html: children }}></span> :
                    children
                }
            </div>
            {id && <div onClick={handleClose} className='
            cursor-pointer h-fit
            bg-black
            bg-opacity-5 hover:bg-opacity-10 rounded-md p-2
            absolute top-4 right-4
            '><CloseIcon className={`fill-black w-6 h-6`} /></div>}
        </div>
    )
}

export default memo(Callout);